<template>
  <div class="search">
    <div class="serachkuang">
      <input :placeholder="placeholder" v-model="name"  @keydown.enter="search"/>
      <div class="sousuo" @click="search">
        <a href="#"><img src="../../src/assets/img/search.png" /></a>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['typename'],
    components: {},
    data() {
      return {
        name:'',
        placeholder:'请输入您想查询的院校'
      };
    },
    computed: {},
    methods: {
      search(){
        console.log(this.name)
        this.$emit("search",this.name)
      },
      clear(){
        this.name = ''
      }
    },
    mounted() {console.log(this.typename)
      if(this.typename == 'major'){
        this.placeholder = '请输入您想查询的专业';
      } else if(this.typename == 'jobzhiyuan'){
        this.placeholder = '请输入您想查询的职业名称';
      } else {
        this.placeholder = '请输入您想查询的院校';
      }
    },
  };
</script>
<style scoped>
  .serachkuang img {
    padding: 9px 15px 9px 15px;
    background: red;
    border-radius: 0 6px 6px 0;
  }

  .serachkuang input {
    border: none;
    width: 630px;
    height: 48px;
    background: #fff;
    opacity: 1;
    border-radius: 6px 0px 0px 6px;
    padding-left: 15px;
  }

  ::-webkit-input-placeholder {
    color: #999999;
  }

  .serachkuang {
    display: flex;
    height: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .search {
    width: 100%;
    height: 100%;
    margin-top: 70px;
    justify-content: center;
    align-items: center;
    background: url(../../src/assets/img/title.icon1.png);
    width: 100%;
    height: 140px;
  }

  @media (max-width: 750px) {
    body {
      width: 100%;
      height: auto;
    }

    .search {
      width: 100%;
      display: flex;
      align-items: center;
    }

    .serachkuang {
      width: 80%;
      height: 48px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/vSerch.vue